export default "__VITE_ASSET__BRsV6Cum__"